import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, HelpCircle } from 'lucide-react';

import { VaultHelpContent } from '../components/VaultHelpContent';

/**
 * VaultHelpDashboardPage
 *
 * Page d'aide / FAQ Coffre-Fort pour les gestionnaires,
 * accessible depuis le dashboard (ProtectedLayout).
 */
export const VaultHelpDashboardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-4xl px-6 py-8">
      {/* Header */}
      <div className="mb-8">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center gap-2 text-sm font-medium text-neutral-500 transition-colors hover:text-neutral-700"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('common.back', 'Retour')}
        </button>

        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-primary-100">
            <HelpCircle className="h-6 w-6 text-primary-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-neutral-900">
              {t('vault.help.title', 'Aide - Coffre-Fort Numérique')}
            </h1>
            <p className="mt-1 text-neutral-500">
              {t('vault.help.subtitle', 'Questions fréquentes et guide d\'utilisation')}
            </p>
          </div>
        </div>
      </div>

      <VaultHelpContent defaultAudience="gestionnaire" showAudienceFilter />
    </div>
  );
};
